import axios from "./axios"

function search(query) {
    return axios().get(`/ledger-accounts-search`, {
        params: {
            search: query
        }
    })
}
export default {
    search
}